import { InputHTMLAttributes, useCallback, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import {
  Checkbox,
  Input,
  InputProps,
  Select,
  SelectProps
} from '../../../../../components/Form'
import { ContainerAnimation } from './styles'
interface FormCompanionProps extends InputHTMLAttributes<HTMLInputElement> {
  inputName: InputProps
  selectRelationship: SelectProps
  label?: string
  positive?: InputProps
  negative?: InputProps
  data: any[]
  setData: React.Dispatch<React.SetStateAction<any[]>>
  index?: number
  parent?: string
  hasHeader?: {
    label?: string
    positive?: InputProps
    negative?: InputProps
  }
  changeTab?: React.SetStateAction<string>
}

export const FormCompanion: React.FC<FormCompanionProps> = ({
  selectRelationship,
  inputName,
  positive,
  negative,
  label,
  data,
  setData,
  index,
  hasHeader,
  changeTab
}) => {
  const {
    register,
    watch,
    setValue,
    getValues,
    formState: { errors },
    clearErrors
  } = useFormContext()
  const watchShowField = hasHeader?.positive?.name
    ? watch(hasHeader?.positive?.name)
    : undefined
  const [copyData, setCopyData] = useState([...data])
  const [showInput, setShowInput] = useState(
    watchShowField || data[index]?.isActive || copyData[index]?.isActive || ''
  )
  const allowClass = ['show', 'show child']

  const handleAddForm = useCallback(
    (status: string) => {
      const showClass = ['show', 'show child']
      if (data[index + 1]) {
        const prefixArray = positive?.name.split('.')
        prefixArray.pop()
        const prefix = prefixArray.join('.')
        const workFields = getValues(prefix)
        if (workFields) {
          const objectEntries = Object.entries(workFields)
          for (let [key] of objectEntries) {
            key = `${prefix}.${key}`

            if (positive?.name !== key) {
              setValue(key, '')
            }
          }
        }
        clearErrors(prefix)
        setData(oldState => {
          const data = [...oldState]

          data[index + 1].isActive = showClass.includes(
            data[index + 1].isActive
          )
            ? 'hidden'
            : 'show'
          return data
        })
      } else {
        setData(oldState => {
          const data = [...oldState]
          data[index + 1] = {
            id: index + 1,
            isActive: showClass.includes(status) ? 'show child' : 'hidden',
            parent: index
          }
          data[index].isActive = 'show'
          return [...data]
        })
      }
    },
    [clearErrors, data, getValues, index, positive?.name, setData, setValue]
  )

  const handleClose = useCallback(() => {
    const showClass = ['show', 'show child']
    const watchField = watch(hasHeader?.positive?.name || '')
    if (watchField === 'hidden') {
      const prefixArray = hasHeader?.positive?.name.split('.')
      prefixArray.pop()
      const prefix = prefixArray.join('.')
      const workFields = getValues(prefix)
      if (workFields) {
        const objectEntries = Object.entries(workFields)
        for (let [key] of objectEntries) {
          key = `${prefix}.${key}`
          if (hasHeader?.positive?.name !== key) {
            setValue(key, '')
          }
        }
      }
      clearErrors(prefix)
    }
    if (showClass.includes(data[index]?.isActive)) {
      setData(oldState => {
        const data = [...oldState]
        data[index].isActive = showClass.includes(data[index].isActive)
          ? 'hidden'
          : 'show child'
        return data
      })
    }
  }, [
    clearErrors,
    data,
    getValues,
    hasHeader?.positive?.name,
    index,
    setData,
    setValue,
    watch
  ])

  return (
    <div className={'row pe-0'}>
      <div>
        {hasHeader?.label && (
          <p className="mb-2 form-check-label text-gray-700 fw-bold  p-0">
            {label}
          </p>
        )}
        <div className="d-flex">
          {hasHeader && hasHeader.positive && (
            <Checkbox
              className="col-xl-1"
              label="Sim"
              inputOptions={{
                classname: 'd-flex align-items-center'
              }}
              register={register}
              {...hasHeader.positive}
              errors={errors}
              type="radio"
              value="show"
              rules={{
                required: changeTab !== 'previous',
                onChange: () => {
                  const watchField = watch(hasHeader.positive.name)
                  if (watchField === 'show') {
                    setCopyData(oldState => {
                      const data = [...oldState]
                      data[index].isActive = 'show'
                      return [...data]
                    })
                    setShowInput('show')
                  } else {
                    handleClose()
                    setShowInput('hidden')
                  }
                }
              }}
              checked={allowClass.includes(showInput)}
              hasCustom
              hasErrorCustom
            />
          )}
          {hasHeader && hasHeader.negative && (
            <Checkbox
              className="col-xl-1"
              label="Não"
              inputOptions={{
                classname: 'd-flex align-items-center'
              }}
              {...hasHeader.negative}
              register={register}
              type="radio"
              value="hidden"
              rules={{ required: changeTab !== 'previous' }}
              errors={errors}
              checked={showInput === 'hidden'}
              hasCustom
            />
          )}
        </div>
      </div>
      <ContainerAnimation
        isShow={showInput}
        id={'companion ' + inputName.name}
        className="companion_container pe-0"
      >
        <div className="row mb-5">
          <Input
            className="col-xl-9"
            label="Nome completo"
            register={register}
            {...inputName}
            rules={
              changeTab !== 'previous'
                ? {
                    required: allowClass.includes(showInput)
                  }
                : { required: false }
            }
            errors={errors}
            hasCustom
          />

          <Controller
            shouldUnregister={true}
            name={selectRelationship.name}
            rules={
              changeTab !== 'previous'
                ? {
                    required: allowClass.includes(showInput)
                  }
                : { required: false }
            }
            render={({ field }) => (
              <Select
                className="col-xl"
                label="Grau de parentesco"
                register={register}
                {...selectRelationship}
                {...field}
                errors={errors}
                hasCustom
              />
            )}
          />
        </div>
        <div className="row mb-5 ">
          <p>Está viajando com mais alguém?</p>
          <div className="d-flex">
            <Checkbox
              className="col-xl-1"
              label="Sim "
              inputOptions={{
                classname: 'd-flex align-items-center'
              }}
              register={register}
              name={positive?.name}
              type="radio"
              value="show"
              rules={{
                onChange: () => {
                  const watchField = watch(positive.name)
                  if (watchField === 'show') {
                    handleAddForm('show')
                  } else {
                    handleAddForm('hidden')
                  }
                }
              }}
              checked={
                data[index + 1]?.isActive === 'show' ||
                data[index + 1]?.isActive === 'show child'
              }
              hasCustom
            />
            <Checkbox
              className="col-xl-1"
              label="Não"
              inputOptions={{
                classname: 'd-flex align-items-center'
              }}
              name={negative?.name}
              register={register}
              type="radio"
              value="hidden"
              checked={data[index + 1]?.isActive === 'hidden'}
              hasCustom
            />
          </div>
        </div>
      </ContainerAnimation>
    </div>
  )
}
